<div (clickOutside)="isToggled? onClickOutside($event) : null"
  [ngClass]="{ show: isToggled, 'dropdown-select': dropdownSelect, disabled: isDisabled }"
  class="dropdown {{ wrapClass }}">
  <button type="button"
    [id]="id"
    data-toggle="dropdown"
    aria-haspopup="listbox"
    [attr.aria-label]="label"
    [attr.aria-expanded]="isToggled"
    [attr.aria-controls]="id + '-menu'"
    (click)="onClick($event)"
    (keyup.escape)="isToggled ? onClickOutside($event) : null"
    class="rs-btn-link text-left d-flex justify-content-between align-items-center stretch-button p-2 dropdown-toggle {{triggerWrapClass}}"
    [ngClass]="dropdownSelect ? 'btn-block select' : 'p-0'">
    @if (!hideLabel) {
      @if (label) {
        <span
        class="label">{{ label | translate }}</span>
      }
      @if (value) {
        <span
        class="value">{{ dropdownValue | translate }}</span>
      }
      @if (!value) {
        <span
        class="value"> {{ label | translate }} </span>
      }
    }
    <ng-content></ng-content>
  </button>
  <div [ngClass]="{show: isToggled, 'dropdown-menu-right': headerDropdown}"
    class="dropdown-menu py-0 px-2"
    role="listbox"
    [id]="id + '-menu'"
    [attr.aria-labelledby]="id">
    @for (item of items; track item; let i = $index) {
      @if (!item.invisible) {
        <button
          class="dropdown-item"
          role="option"
          [ngClass]="{ 'active': (multiple && value && value.includes(item.value)) || (!multiple && value === item.value)}"
          type="button"
          (keyup.escape)="isToggled ? onClickOutside($event) : null"
          [attr.aria-selected]="value === item.value"
          (click)="onSelect($event, item, i)">
          {{ item.label | translate }}
        </button>
      }
    }
  </div>
</div>
